import { Node, mergeAttributes } from "@tiptap/core";

export const LayoutContainer = Node.create({
  name: "layoutContainer",

  group: "block",

  content: "block*",

  addAttributes() {
    return {
      style: {
        default: null,
      },
      class: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div",
      },
      {
        tag: "section",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes), 0];
  },
});
